import { Component, DoCheck, KeyValueDiffer, KeyValueDiffers, OnInit } from '@angular/core';
import { StylesService } from '../../../../Common/Styles/services/styles.service';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { TableOfContentDisplayElementModel } from '../../models/table-of-content-display-element.model';
import { BriefingTextStyleFieldComponent } from '../../../Shared/components/BriefingTextStyleField/briefing-text-style-field.component';
import { TableOfContentOrientationEnum } from '../../enums/table-of-content-orientation.enum';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';

@Component({
    selector: 'agpr-table-of-content-style-field',
    templateUrl: '../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component.html',
    styleUrls: ['../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component.scss'],
    standalone: false
})
export class TableOfContentStyleFieldComponent extends BriefingTextStyleFieldComponent implements OnInit, DoCheck {
    settingsDiffer: KeyValueDiffer<string, any>;

    constructor(
        public differs: KeyValueDiffers,
        coreDialogService: CoreDialogService,
        stylesService: StylesService,
        briefingsService: AbstractPageBuilderService
    ) {
        super(coreDialogService, stylesService, briefingsService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.settingsDiffer = this.differs.find((<TableOfContentDisplayElementModel>this.block.displayElement).settings).create();
    }

    ngDoCheck() {
        if (this.settingsDiffer.diff((<TableOfContentDisplayElementModel>this.block.displayElement).settings)) {
            this.toggleAlignmentOptionsVisibility();
        }
    }

    toggleAlignmentOptionsVisibility() {
        const alignment = (<TableOfContentDisplayElementModel>this.block.displayElement).settings.orientation;

        if (alignment === TableOfContentOrientationEnum.vertical) {
            this.field.showAlignmentButtons = false;

            return;
        }

        this.field.showAlignmentButtons = true;
    }
}
